/**
 * The below file contains the wards name object
 * @author: shivam.sharma2@velsof.com
 * @date : 29-12-2022
 */

import {
  SET_ALL_WARDS
} from "redux/constants/Wards";

//Initial state
const initState = {
  //Keys for wards name 
  wardsName: [],
  //Keys for wards name 
};

/**
 * Function to sort ward names naturally (Ward 1, Ward 2, Ward 11)
 * @param {Array} wards Array of wards
 * @returns {Array} Sorted wards array
 */
const sortWardsNaturally = (wards) => {
  return wards.sort((a, b) => {
    // First sort by village name
    const villageCompare = a.village?.villageName?.localeCompare(b.village?.villageName);
    if (villageCompare !== 0) return villageCompare;
    
    // Then sort ward names naturally
    const aMatch = a.name.match(/Ward (\d+)/);
    const bMatch = b.name.match(/Ward (\d+)/);
    
    if (aMatch && bMatch) {
      const aNum = parseInt(aMatch[1]);
      const bNum = parseInt(bMatch[1]);
      return aNum - bNum;
    }
    
    // Fallback to string comparison
    return a.name.localeCompare(b.name);
  });
};

/**
 * Function to format ward names with village names for differentiation
 * @param {Array} wards Array of wards
 * @returns {Array} Formatted wards array
 */
const formatWardsWithVillageNames = (wards) => {
  return wards.map(ward => ({
    ...ward,
    displayName: `${ward.name} (${ward.village?.villageName || ward.villageName})`,
    searchableText: `${ward.name} ${ward.village?.villageName || ward.villageName}`.toLowerCase()
  }));
};

/**
 * The below function will update the state on the basis of action type.
 * @param {any} state State
 * @param {any} action Action
 * @returns Json object
 */
const Wards = (state = initState, action) => {
  switch (action.type) {
    //Cases for listing
    case SET_ALL_WARDS:
      let processedWards = action.payload.data || [];
      
      // Sort wards naturally and format with village names
      processedWards = sortWardsNaturally(processedWards);
      processedWards = formatWardsWithVillageNames(processedWards);
      
      return {
        ...state,
        wardsName: processedWards,
      };

    default:
      return state;
  }
};

export default Wards;
